import "core-js/modules/es6.array.fill";
import './index-2cd7e630.js';
import './helpers-d8b49b57.js';
import { c as createAnimation } from './animation-f72ade61.js';
import { g as getIonPageElement } from './index-157155ee.js';

var mdTransitionAnimation = function mdTransitionAnimation(_, opts) {
  var OFF_BOTTOM = '40px';
  var CENTER = '0px';
  var backDirection = opts.direction === 'back';
  var enteringEl = opts.enteringEl;
  var leavingEl = opts.leavingEl;
  var ionPageElement = getIonPageElement(enteringEl);
  var enteringToolbarEle = ionPageElement.querySelector('ion-toolbar');
  var rootTransition = createAnimation();
  rootTransition.addElement(ionPageElement).fill('both').beforeRemoveClass('ion-page-invisible'); // animate the component itself

  if (backDirection) {
    rootTransition.duration(opts.duration || 200).easing('cubic-bezier(0.47,0,0.745,0.715)');
  } else {
    rootTransition.duration(opts.duration || 280).easing('cubic-bezier(0.36,0.66,0.04,1)').fromTo('transform', "translateY(".concat(OFF_BOTTOM, ")"), "translateY(".concat(CENTER, ")")).fromTo('opacity', 0.01, 1);
  } // Animate toolbar if it's there


  if (enteringToolbarEle) {
    var enteringToolBar = createAnimation();
    enteringToolBar.addElement(enteringToolbarEle);
    rootTransition.addAnimation(enteringToolBar);
  } // setup leaving view


  if (leavingEl && backDirection) {
    // leaving content
    rootTransition.duration(opts.duration || 200).easing('cubic-bezier(0.47,0,0.745,0.715)');
    var leavingPage = createAnimation();
    leavingPage.addElement(getIonPageElement(leavingEl)).afterStyles({
      'display': 'none'
    }).fromTo('transform', "translateY(".concat(CENTER, ")"), "translateY(".concat(OFF_BOTTOM, ")")).fromTo('opacity', 1, 0);
    rootTransition.addAnimation(leavingPage);
  }

  return rootTransition;
};

export { mdTransitionAnimation };